
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getTaskstatus = async () => {
  return await get<ApiResponse<any[]>>("/taskstatus").then((res)=>{
      return res
    })
};

 